import { render, staticRenderFns } from "./RibbonTags.vue?vue&type=template&id=d6db3d02&scoped=true&"
import script from "./RibbonTags.vue?vue&type=script&lang=js&"
export * from "./RibbonTags.vue?vue&type=script&lang=js&"
import style0 from "./RibbonTags.vue?vue&type=style&index=0&id=d6db3d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6db3d02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
